var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builds"},[_c('vue-good-table',{ref:"table",attrs:{"columns":_vm.columns,"rows":_vm.builds,"sort-options":{
      enabled: true,
      initialSortBy: {
        field: 'assembly_at',
        type: 'asc'
      }
    },"pagination-options":{
      enabled: true,
      perPage: 20,
      nextLabel: _vm.$t('pagination.next'),
      prevLabel: _vm.$t('pagination.back'),
      rowsPerPageLabel: _vm.$t('pagination.output'),
      allLabel: _vm.$t('pagination.all'),
      ofLabel: _vm.$t('pagination.of'),
    }},on:{"on-row-click":_vm.onClickBuildsRow,"on-column-filter":_vm.onColumnFilter},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'size')?_c('span',[_vm._v(_vm._s(_vm._f("dimensions")(_vm.formatSize(props))))]):(props.column.field == 'options')?_c('span',{staticClass:"btn-icon__wrapper vgt-table__options-cell"},[_c('router-link',{staticClass:"btn btn-icon",attrs:{"title":"Посмотреть карточку клиента","to":{
            name: 'clients.client',
            params: { clientId: _vm.getClientId(props.index) }
          }}},[_c('font-awesome-icon',{staticClass:"sidebar__menu-icon",attrs:{"icon":"user"}})],1),_c('router-link',{staticClass:"btn btn-icon",attrs:{"title":"Посмотреть заказ","to":{
            name: 'orders.order',
            params: { orderId: _vm.getOrderId(props.index) },
          }}},[_c('font-awesome-icon',{staticClass:"sidebar__menu-icon",attrs:{"icon":"eye"}})],1),_c('router-link',{staticClass:"btn btn-icon",attrs:{"title":"Написать клиенту","to":{ name: 'orders.order', hash:'#clientdata', params: {
            orderId: _vm.getOrderId(props.index),
            action: 'client' 
          }}}},[_c('font-awesome-icon',{staticClass:"sidebar__menu-icon",attrs:{"icon":"pen"}})],1)],1):_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))])]}}])},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("Установите планируемую \"Дату монтажа\" на страницах ваших заказов и здесь будет отображаться наглядный график монтажей ваших заказов")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }